import { useContext } from 'react';
import { Icon } from '@ok/okd';
import CurrencyInfoContext from '@pages/currencyInfo/context';
import { toLocale } from '@common/i18n';
import { PLACEHOLDER } from '@pages/currencyInfo/common/context';

import './index.less';

const Resource = () => {
  const { currencyInfo } = useContext(CurrencyInfoContext);

  const {
    officialWebsite,
    githubRepository,
    blockchainExplorer,
    twitter,
    whitePaper,
    facebook,
    symbol = PLACEHOLDER,
    fullName = PLACEHOLDER,
  } = currencyInfo;

  const resources = [
    {
      url: officialWebsite,
      icon: 'okj-common-slice',
      text: toLocale('currency_office_site'),
    },
    {
      url: whitePaper,
      icon: 'okj-common-whitepaper',
      text: toLocale('currency_white_paper'),
    },
    {
      url: githubRepository,
      icon: 'okj-common-github',
      text: toLocale('currency_office_github'),
    },
    {
      url: blockchainExplorer,
      icon: 'okj-common-browser',
      text: toLocale('currency_block_explorer'),
    },
    {
      url: twitter,
      icon: 'okj-common-x',
      text: toLocale('currency_block_twitter'),
    },
    {
      url: facebook,
      icon: 'okj-common-facebook-code',
      text: toLocale('currency_block_facebook'),
    },
  ];

  return (
    <div className="resource-wrapper">
      <div className="resource-title">
        {toLocale('resource_title_about', {
          symbol: symbol,
          currencyFullName: fullName,
        })}
      </div>
      <div className="resource-content">
        {resources.map(({ url, icon, text }) => {
          return (
            url && (
              <a
                key={url}
                className="icon-wrapper"
                href={url}
                target="_blank"
                rel="noreferrer"
              >
                <Icon className={icon} />
                <span className="resource-text">{text}</span>
              </a>
            )
          );
        })}
      </div>
    </div>
  );
};

export default Resource;
